export enum EnvEnum
{
  DEV   = 'dev',
  PROD  = 'prod',
  PPRD  = 'pprd',
  GIO   = 'gio',
}
